import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import "./Container.css";
var styles = { "container": "b0981f", "container-xsmall": "e41f31", "container-small": "f7fea1", "container-medium": "cbcab3", "container-large": "a3282c", "container-xlarge": "e5117f", "container_fullWidth": "d0fdd1" };
const Container = forwardRef((_a, ref) => {
    var { children, className, maxWidth, Tag = 'div', hasFullWidth = false } = _a, props = __rest(_a, ["children", "className", "maxWidth", "Tag", "hasFullWidth"]);
    return (React.createElement(Tag, Object.assign({ className: cn(styles.container, !!maxWidth && styles[`container-${maxWidth}`], hasFullWidth && styles.container_fullWidth, className), ref: ref }, props), children));
});
export default Container;
//# sourceMappingURL=Container.js.map